// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"49":"gifs","443":"about","759":"stickers"}[chunkId] + "." + {"49":"81daf498","443":"3ac0ed5e","759":"406fdc49"}[chunkId] + ".js";
};